import { NavLink, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import "../assets/css/hrmcrm-sidebar.css";
import logo from "../assets/img/gmt_logo.png";

export default function SidebarAdmin() {
  const [openSection, setOpenSection] = useState(null);
  const location = useLocation();

  const toggleSection = (section) => {
    setOpenSection((prev) => (prev === section ? null : section));
  };

 useEffect(() => {
  const path = location.pathname;

  if (
   path.startsWith("/dashboard/admin/loan-management") ||
    path.startsWith("/dashboard/admin/active-loans") ||
    path.startsWith("/dashboard/admin/payslip-upload") ||
   path.startsWith("/dashboard/admin/repayment-upload") ||
path.startsWith("/dashboard/admin/loan-reports")
  ) {
    setOpenSection("loans");
  } 
  else if (path.startsWith("/dashboard/loans")) {
    setOpenSection("approvals");
  } 
 else if (
  path.startsWith("/dashboard/settings") ||
  path.startsWith("/dashboard/admin/loan-settings")
) {
  setOpenSection("system");
}
  else {
    setOpenSection(null);
  }
}, [location.pathname]);


  return (
    <div className="hrmcrm-sidebar">

      <div className="sidebar-logo">
        <img src={logo} alt="GMT Logo" className="sidebar-logo-img" />
        <div className="sidebar-logo-text">
          <h4>GMT</h4>
          <small>Admin Portal</small>
        </div>
      </div>

      <NavLink
        to="/dashboard/admin"
        end
        className={({ isActive }) =>
          isActive ? "sidebar-link active" : "sidebar-link"
        }
      >
        <i className="fa fa-home sidebar-icon" />
        <span className="sidebar-text">Overview</span>
      </NavLink>

   <SidebarSection
  title="Loan Operations"
  icon="fa-university"
  sectionKey="loans"
  openSection={openSection}
  toggleSection={toggleSection}
>
  <SidebarSubLink to="/dashboard/admin/loan-management" icon="fa-file-signature">
  Loan Management
</SidebarSubLink>

  <SidebarSubLink to="/dashboard/admin/active-loans" icon="fa-folder-open">
    Active Loans
  </SidebarSubLink>


<SidebarSubLink to="/dashboard/admin/loan-reports" icon="fa-chart-line">
  Loan Reports
</SidebarSubLink>

  <SidebarSubLink
    to="/dashboard/admin/repayment-upload"
    icon="fa-upload"
  >
    Repayment Upload
  </SidebarSubLink>

  <SidebarSubLink
    to="/dashboard/admin/payslip-upload"
    icon="fa-file-upload"
  >
    Payslip Upload
  </SidebarSubLink>
</SidebarSection>

<SidebarSection
  title="Approvals"
  icon="fa-user-check"
  sectionKey="approvals"
  openSection={openSection}
  toggleSection={toggleSection}
>
  <SidebarSubLink
  to="/dashboard/loans/approved"
  icon="fa-check-circle"
>
  Approved Loans
</SidebarSubLink>
</SidebarSection>

      <SidebarSection
        title="System"
        icon="fa-cogs"
        sectionKey="system"
        openSection={openSection}
        toggleSection={toggleSection}
      >
        <SidebarSubLink
          to="/dashboard/settings/notifications"
          icon="fa-bell"
        >
          Notifications
        </SidebarSubLink>

         <SidebarSubLink
    to="/dashboard/admin/loan-settings"
    icon="fa-sliders-h"
  >
    Loan Settings
  </SidebarSubLink>
      </SidebarSection>

    </div>
  );
}

function SidebarSection({
  title,
  icon,
  sectionKey,
  openSection,
  toggleSection,
  children,
}) {
  return (
    <div className="sidebar-section">
      <button
        className="sidebar-dropdown-toggle"
        onClick={() => toggleSection(sectionKey)}
      >
        <div className="sidebar-row">
          <i className={`fa ${icon} sidebar-icon`} />
          <span className="sidebar-text">{title}</span>
        </div>

        <i
          className={`fa fa-chevron-${
            openSection === sectionKey ? "down" : "right"
          } sidebar-chevron`}
        />
      </button>

      {openSection === sectionKey && (
        <div className="sidebar-submenu">{children}</div>
      )}
    </div>
  );
}

function SidebarSubLink({ to, icon, children }) {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        isActive ? "sidebar-sublink active" : "sidebar-sublink"
      }
    >
      <i className={`fa ${icon} sidebar-icon`} />
      <span className="sidebar-text d-flex align-items-center w-100">
        {children}
      </span>
    </NavLink>
  );
}